import { getEntityId } from './getEntityId';

import type { ContextSearchPlace } from '@web-platform/shared-universal-types/src/context';

export const getPlaceOfStay = (destination: ContextSearchPlace) =>
  destination?.travelEntityId || getEntityId(destination);
